import { Button, Typography } from "@mui/material";
import CustomDialog from "../../../commons/dialog/customDialog";
import { StyledDialog } from "../../../styled/dialog";
import {
  StyledFormHeader,
  StyledFpaAuthorizationDialog,
} from "../../../styled/form";

const FpaAutorizationDialog = ({
  open,
  title,
  handleSubmit,
  codigoAutorizacion,
}) => {
  return (
    <CustomDialog open={open}>
      <StyledFpaAuthorizationDialog.TitleContainer>
        <Typography sx={StyledFormHeader.text}>{title}</Typography>
      </StyledFpaAuthorizationDialog.TitleContainer>
      <div>
        {codigoAutorizacion ? (
          <StyledFpaAuthorizationDialog.ContentContainer>
            <Typography>
              El Pedido de Autorización realizado ha sido APROBADO con el
              Código:
            </Typography>
            <Typography>
              <strong>{codigoAutorizacion}</strong>
            </Typography>
          </StyledFpaAuthorizationDialog.ContentContainer>
        ) : (
          <StyledFpaAuthorizationDialog.ContentContainer>
            <Typography>
              El Pedido de Autorización realizado se encuentra en gestión
            </Typography>
          </StyledFpaAuthorizationDialog.ContentContainer>
        )}
        <StyledDialog.Actions>
          <Button
            variant="contained"
            color="secondary"
            type="button"
            onClick={() => {
              handleSubmit();
            }}>
            Aceptar
          </Button>
        </StyledDialog.Actions>
      </div>
    </CustomDialog>
  );
};

export default FpaAutorizationDialog;
